import { createFileRoute } from "@tanstack/react-router";
import { BlogIndexPage, blogIndexHeadEn } from "@/pages/BlogIndexPage";

export const Route = createFileRoute("/en/blog/")({
  head: blogIndexHeadEn,
  component: BlogIndexPage,
});
